<template>
  <b-card>
  <div class="unprotected" >
    <h5 >Please login</h5>

    <form @submit.prevent="callLogin()">
      <input type="text" placeholder="username" v-model="username">
      <input type="password" placeholder="password" v-model="password">
      <b-btn variant="primary" type="submit">Login</b-btn>
      <p v-if="error" class="error">Wrong username or password</p>
    </form>
  </div>
  </b-card>
</template>

<script>

export default {
  name: 'login',

  data () {
    return {
      username: '',
      password: '',
      error: false,
      loading: false,
      message: ''
    }
  },
  methods: {
    callLogin () {
      this.error = false
      this.loading = true
      const username = this.username
      const password = this.password
      console.log('dispatching login to store')
      this.$store.dispatch('login', { username, password })
        .then(
          () => {
            this.$router.push('/')
          },
          error => {
            this.loading = false
            this.error = true
            this.message =
              (error.response && error.response.data) ||
              error.message ||
              error.toString()
          })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue